import { service } from '@ember/service';
import Component from '@glimmer/component';
import type { Task } from 'ember-concurrency';
import { dropTask } from 'ember-concurrency';
import type BadgeModel from 'garaje/models/badge';
import type PhotoPageModel from 'garaje/models/photo-page';
import type StateService from 'garaje/services/state';
import { alias } from 'macro-decorators';

interface FlowsSectionsPhotoComponentSignature {
  Args: {
    updateAndSaveTask: Task<void, [PhotoPageModel, string, boolean]>;
    badge: BadgeModel;
    photoPage: PhotoPageModel;
  };
}

export default class FlowsSectionsPhotoComponent extends Component<FlowsSectionsPhotoComponentSignature> {
  @service declare state: StateService;

  @alias('state.vrSubscription') vrSubscription!: StateService['vrSubscription'];

  get hasAccessToVisitorPhotos(): boolean {
    return Boolean(this.state.features?.canAccessVisitorPhotos);
  }

  updateFeature = dropTask(async (photoPage: PhotoPageModel, value: boolean) => {
    await this.args.updateAndSaveTask.perform(photoPage, 'enabled', value);

    // if user turns off photos, badge showPhoto is set to false.
    if (!value) {
      const badge = this.args.badge;

      if (badge.showPhoto) {
        badge.showPhoto = false;
        await badge.save();
      }
    }
  });
}
